import { render, staticRenderFns } from "./CustomerMigPal.vue?vue&type=template&id=761c337d"
import script from "./CustomerMigPal.vue?vue&type=script&lang=js"
export * from "./CustomerMigPal.vue?vue&type=script&lang=js"
import style0 from "./CustomerMigPal.vue?vue&type=style&index=0&id=761c337d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports